<template>
  <div class="label-field">
    <div v-if="flex" class="d-flex">
      <span class="font-weight-bold mr-3">{{ label + ':' }}</span>
      <span class="font-weight-medium">{{ value }}</span>
    </div>

    <v-row v-else-if="small">
      <v-col cols="6" lg="2" class="pb-0">
        <span class="font-weight-bold">{{ label + ':' }}</span>
      </v-col>
      <v-col cols="6" lg="3">
        <span class="font-weight-medium">{{ value }}</span>
      </v-col>
    </v-row>

    <v-row v-else justify="start">
      <v-col cols="12" lg="5" class="pb-0">
        <span class="font-weight-bold">{{ label + ':' }}</span>
      </v-col>
      <v-col cols="12" lg="7">
        <span class="font-weight-medium">{{ value }}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "LabelField",
  props: {
    label: String,
    value: [String, Number, Boolean],
    small: Boolean,
    flex: Boolean
  },
};
</script>
